<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @addTab1="addTab1()" @addTab2="addTab2()" @addTab3="addTab3()" @addTab4="addTab4()" @addTab5="addTab5()" @addTab6="addTab6()"  @removeTab="removeTab(item.name)" :minor='5'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * 李旭
 * 矿业展会管理页面
 */
import {mapState} from 'vuex'
import KyzhAdd from '../../../../static/form/KyzhAdd.vue'
import KyltMAdd from '../../../../static/form/KyltMAdd.vue'
import KyltPdfAdd from '../../../../static/form/KyltPdfAdd.vue'
import KyltTitleAdd from '../../../../static/form/KyltTitleAdd.vue'
import KyzhLb from '../assembly/KyzhLb.vue'
import YqjbLB from '../assembly/YqjbLB.vue'
import YqjbAdd from '../../../../static/form/YqjbAdd.vue'
import SponsorLB from '../assembly/SponsorLB.vue'
import SponsorAdd from '../../../../static/form/SponsorAdd.vue'
import KyltMLB from '../assembly/KyltMLB.vue'
import KyltPdfLB from '../assembly/KyltPdfLB.vue'
import KyltTitleLB from '../assembly/KyltTitleLB.vue'
import ComboBox from '../assembly/ComboBox.vue'
import Classification from '../assembly/Classification.vue'
export default {
  components: {
    KyzhAdd,
    KyzhLb,
    ComboBox,
    Classification,
    KyltMLB,
    KyltPdfLB,
    KyltTitleLB,
    KyltMAdd,
    KyltPdfAdd,
    KyltTitleAdd,
    YqjbLB,
    YqjbAdd,
    SponsorLB,
    SponsorAdd
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '矿业展会列表',
        name: '1',
        closable: false,
        ref: 'child',
        content: KyzhLb
      },
      {
        title: '分类管理列表',
        name: '2',
        closable: false,
        content: Classification
      },
      {
        title: '大会邀请函',
        name: '3',
        closable: false,
        content: KyltPdfLB
      },
      {
        title: '矿业论坛会议列表',
        name: '4',
        closable: false,
        content: KyltMLB
      },
      {
        title: '报名页标题列表',
        name: '6',
        closable: false,
        content: KyltTitleLB
      },
      {
        title: '往届嘉宾列表',
        name: '7',
        closable: false,
        content: YqjbLB
      },
      {
        title: '单位列表',
        name: '8',
        closable: false,
        content: SponsorLB
      }],
      addobj: {
        title: '添加矿业展会',
        name: '9',
        closable: true,
        content: KyzhAdd
      },
      addobj1: {
        title: '添加矿业论坛会议',
        name: '10',
        closable: true,
        content: KyltMAdd
      },
      addobj3: {
        title: '添加矿业论坛pdf',
        name: '12',
        closable: true,
        content: KyltPdfAdd
      },
      addobj4: {
        title: '添加报名页标题',
        name: '13',
        closable: true,
        content: KyltTitleAdd
      },
      addobj5: {
        title: '添加往届嘉宾',
        name: '14',
        closable: true,
        content: YqjbAdd
      },
      addobj6: {
        title: '添加举办单位',
        name: '15',
        closable: true,
        content: SponsorAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    addTab1()
    {
      this.editableTabs.push(this.addobj1)
      this.editableTabsValue = this.addobj1.name
    },
    addTab2()
    {
      this.editableTabs.push(this.addobj2)
      this.editableTabsValue = this.addobj2.name
    },
    addTab3()
    {
      this.editableTabs.push(this.addobj3)
      this.editableTabsValue = this.addobj3.name
    },
    addTab4()
    {
      this.editableTabs.push(this.addobj4)
      this.editableTabsValue = this.addobj4.name
    },
    addTab5()
    {
      this.editableTabs.push(this.addobj5)
      this.editableTabsValue = this.addobj5.name
    },
    addTab6()
    {
      this.editableTabs.push(this.addobj6)
      this.editableTabsValue = this.addobj6.name
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/Kyzhgl.vue